import { TGender, TMessagesType, TUserType } from "../../Types";
import {
  E_NOTIFICATION_REACTION_ACTION,
  E_NOTIFICATION_TYPE
} from "./constants";

export type TNotificationType = `${E_NOTIFICATION_TYPE}`;

export type TNotificationConversationPayload = {
  conversationType: "101C" | "101M" | "102";
  conversationID: string;
  clientUserID?: number;
};

export type TNotificationClientPayload = {
  clientUserID: number;
};

export type TNotificationUnassignedClientPayload = TNotificationClientPayload & {
  userType: TUserType;
};

export type TNotificationPayloadMap = {
  [E_NOTIFICATION_TYPE.KHATTABAT_CONVERSATION_MESSAGE]: TNotificationConversationPayload & {
    messageID: number;
    gender: TGender;
    message: string;
    messageType: TMessagesType;
    senderUUID: string;
  };

  [E_NOTIFICATION_TYPE.KHATTABAT_CONVERSATION_MESSAGE_REACTION]: TNotificationConversationPayload & {
    messageID: number;
    senderUUID: string;
    recipientUUID: string;
    reaction: string;
    action: `${E_NOTIFICATION_REACTION_ACTION}`;
    reactedOn: string;
  };

  [E_NOTIFICATION_TYPE.KHATTABAT_CONVERSATION_MESSAGE_READ]: TNotificationConversationPayload & {
    messageID: number;
  };

  [E_NOTIFICATION_TYPE.KHATTABAT_NEW_CLIENT_TO_BE_ASSIGNED]: TNotificationUnassignedClientPayload;

  [E_NOTIFICATION_TYPE.KHATTABAT_NEW_CLIENT_ASSIGNED]: TNotificationUnassignedClientPayload & {
    assignedByAdminID: number;
  };

  [E_NOTIFICATION_TYPE.KHATTABAT_CLIENT_PAID_PHASE]: TNotificationClientPayload & {
    isIntroductory: boolean;
  };

  [E_NOTIFICATION_TYPE.KHATTABAT_REMUNERATION_UPDATE]: TNotificationClientPayload;

  [E_NOTIFICATION_TYPE.KHATTABAT_CLIENT_SUBSCRIPTION_RENEWED]: TNotificationClientPayload;

  [E_NOTIFICATION_TYPE.KHATTABAT_CONVERSATION_DELETED]: TNotificationConversationPayload;

  [E_NOTIFICATION_TYPE.KHATTABAT_CONVERSATION_EXITED]: TNotificationConversationPayload & {
    exitedByUUID: string;
    exitedOn: string;
  };

  [E_NOTIFICATION_TYPE.KHATTABAT_CONVERSATION_ACCEPTED]: TNotificationConversationPayload;
};

export type TNotification = {
  [K in E_NOTIFICATION_TYPE]: {
    notificationType: K;
    payload: TNotificationPayloadMap[K];
    dataOnly: boolean;
  };
}[E_NOTIFICATION_TYPE];

export type TNotificationData = {
  notificationType: string;
  payload: object;
  dataOnly: boolean;
};

export const DEFAULT_NOTIFICATION_DATA: TNotificationData = {
  notificationType: "",
  payload: {},
  dataOnly: false
};
